import { render } from "./ConfirmExcludedParticipantModal.molecules.vue?vue&type=template&id=c4e59c7c"
import script from "./ConfirmExcludedParticipantModal.molecules.vue?vue&type=script&lang=js"
export * from "./ConfirmExcludedParticipantModal.molecules.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__